import { render, staticRenderFns } from "./OnboardingMain.vue?vue&type=template&id=6b8b5d04&scoped=true&"
import script from "./OnboardingMain.vue?vue&type=script&lang=js&"
export * from "./OnboardingMain.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingMain.vue?vue&type=style&index=0&id=6b8b5d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b5d04",
  null
  
)

export default component.exports